import React from "react";
import { Link } from "react-router-dom";
import { BarbellIcon, CaretLeftIcon, StarIcon } from "@phosphor-icons/react";
import { CustomBadge } from "../../../shared/CustomBadge/CustomBadge";
import styles from "../AthleteExerciseHistoryPage.module.scss";

interface ExerciseHeaderProps {
  athleteId: string;
  exerciseId: string;
  exerciseName: string;
  category?: string;
  recommendedForTesting?: boolean;
}

const ExerciseHeader: React.FC<ExerciseHeaderProps> = ({
  athleteId,
  exerciseId,
  exerciseName,
  category,
  recommendedForTesting,
}) => {
  return (
    <>
      <Link to={`/dashboard/users/${athleteId}`} className={styles.backLink}>
        <CaretLeftIcon size={16} weight="bold" />
        Torna al profilo atleta
      </Link>

      <div className={styles.header}>
        <div className={styles.iconWrap}>
          <BarbellIcon size={32} weight="bold" color="#00212c" />
        </div>

        <div className={styles.headerInfo}>
          <div className={styles.titleRow}>
            <h1 className={styles.exerciseTitle}>{exerciseName}</h1>
            {recommendedForTesting && (
              <CustomBadge
                label="Consigliato"
                color="lightgreen"
              />
            )}
            {recommendedForTesting && (
              <StarIcon size={14} weight="fill" color="#ffd15a" />
            )}
          </div>

          <div className={styles.metaRow}>
            <span className={styles.metaLabel}>Atleta:</span>
            <span className={styles.metaValue}>{athleteId}</span>
            <span className={styles.metaSep}>·</span>
            <span className={styles.metaLabel}>Esercizio:</span>
            <span className={styles.metaValue}>{exerciseId}</span>
            {category && (
              <>
                <span className={styles.metaSep}>·</span>
                <span className={styles.metaLabel}>Categoria:</span>
                <span className={styles.metaValue}>{category}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExerciseHeader;
